// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all service-options ( Array )
		optionList: [],

		// Current Option being manipulated ( viewed or edited ) ( Object )
        status: '',
        activeOption: {}
	},

	mutations: {

		// Update optionList with new list
		// @params: Array
		updateOptionList( state, newList ) {
			state.optionList = newList;
		},

		// Add a option into optionList
		addOption( state, newOption ) {
			state.optionList.push( newOption );
		},

		// Delete a testimmonial from optionList
		// @params: identifier (String)
		deleteOption( state, identifier ) {
			state.optionList = state.optionList.filter(option => {
				return option.id != identifier;
			});
		},

		// Update the current active Option object
		// @params: newActiveOption (Object)
		updateActiveOption( state, newActiveOption ) {
			state.activeOption = newActiveOption;
		},

		// Change status of optionForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activeOption = {};
		}

	},

	actions: {
		
		/* 
		*  /GET service-options API
		*  Get all service-options from the server
		*  @return: Array
		*/
		getOptions( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/cms/service-options',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateOptionList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id service-options API
		*  Get a single option from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleOption( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: 'cms/service-options/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateActiveOption', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST service-options API
		*  Add a new option to the server
		*  @params: Object (service-options data)
		*  @return: Object
		*/
		addOption( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {
				const postData = {
					clientname: data.clientname,
					content: data.content,
					profilePhoto: data.profilePhoto,
				};

				global.axios.request({
					method: 'post',
					url: '/cms/service-options/addnew',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addOption', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id service-options API
		*  Edits an existing option into the server
		*  @params: Object (option data)
		*  @return: Object
		*/
		editOption( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {
				const postData = {
					name_r1: data.name_r1,
					name_r2: data.name_r2,
					icon: data.icon,
					description: data.description,
					price: data.price,
					price_type: data.price_type,
					promotion_desc: data.promotion_desc
				};

				global.axios.request({
					method: 'post',
					url: 'cms/service-options/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addOption', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id service-options API
		*  Removes an existing option into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteOption( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: 'cms/service-options/' + identifier + '/delete',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteOption', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/ServiceOptions.js